import type { JSX } from 'react';
import CustomTypography from '../Common/Typography';

export default function NoDataToLoad({
  hasMore = false,
}: { hasMore?: boolean}): JSX.Element {
  return (
    <CustomTypography
      variant="bodySmall"
      fontWeight="bold"
      sx={{
        display: 'block',
        width: '100%',
        textAlign: 'center',
      }}
    >
      No
      {hasMore ? ' more' : ''}
      {' '}
      data to load
    </CustomTypography>
  );
}
